import * as constants from './LoginPhone.constants';
import * as services from './LoginPhone.service';

const state = {
  loginPhoneStatus: 0,
  loginPhoneMessage: '',
};

const mutations = {
  [constants.POST_LOGIN_BIND_MOBILE_SUCCESS](state, data) {
    state.loginPhoneStatus = data.status;
    state.loginPhoneMessage = data.message;
  },
};

const actions = {
  async postLoginBindMobile({ commit }, payload) {
    const res = await services.postLoginBindMobile(payload);
    commit(constants.POST_LOGIN_BIND_MOBILE_SUCCESS, res.data);
  },
};

const getters = {
  loginPhoneStatus: state => state.loginPhoneStatus,
  loginPhoneMessage: state => state.loginPhoneMessage,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
